<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">KNOWLEDGE devoid of virtue is mere vanity; POWER devoid of values is sure calamity; WEALTH cannot be invested in immortality; WISDOM originates from the ultimate reality.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?76e7cb8c